import { render, staticRenderFns } from "./CreateCustomerSalesQuotePopUp.vue?vue&type=template&id=60ed0d7e&scoped=true&"
import script from "./CreateCustomerSalesQuotePopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerSalesQuotePopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerSalesQuotePopUp.vue?vue&type=style&index=0&id=60ed0d7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed0d7e",
  null
  
)

export default component.exports